import {
  Account,
  InboundAddress,
  Msg,
  Network,
  Simulation,
  TxResult,
} from "rujira.js";
import { Xumm } from "xumm";
import type { ResolvedFlow } from "xumm-oauth2-pkce";
import { Providers, WalletProvider } from "./types";

export type XamanContext = ResolvedFlow;

export class XamanAdapter implements WalletProvider<XamanContext> {
  private xumm: Xumm;
  constructor(apiKey: string) {
    this.xumm = new Xumm(apiKey);
  }
  async getAccounts(): Promise<
    { context: XamanContext; account: { address: string; network: Network } }[]
  > {
    const x = await this.xumm.authorize();
    if (x instanceof Error) throw x;
    if (!x) throw new Error(`No account returned`);
    return [
      { context: x, account: { address: x.me.account, network: Network.Xrp } },
    ];
  }
  async simulate(
    _context: XamanContext,
    _account: Account<keyof Providers>,
    _tx: Msg,
    inboundAddress?: InboundAddress
  ): Promise<Simulation> {
    return {
      symbol: "XRP",
      decimals: 6,
      amount: inboundAddress?.gasRate || 0n,
      gas: inboundAddress?.gasRate || 0n,
    };
  }
  async signAndBroadcast(
    _context: XamanContext,
    account: Account<keyof Providers>,
    _simulation: Simulation,
    tx: Msg,
    inboundAddress?: InboundAddress
  ): Promise<TxResult> {
    if (!this.xumm.payload) throw new Error(`No xumm payload`);
    const payment = await tx.toXrpPayment(account, inboundAddress);
    const { resolved, payload } = await this.xumm.payload.createAndSubscribe(
      payment,
      (x) => {
        if ("signed" in x.data) return x;
      }
    );

    await resolved;

    if (!payload.meta.signed) throw new Error("User Rejected Transaction");

    switch (payload.response.dispatched_result?.slice(0, 3)) {
      // Success
      case "tes":
        if (!payload.response.txid) throw new Error("No txid returned");
        return {
          network: Network.Xrp,
          address: account.address,
          txHash: payload.response.txid,
          deposited: tx.toDeposit?.(),
        };
      default:
        throw new Error(payload.response.dispatched_result || "Unknown Error");
    }
  }
  isAvailable() {
    return true;
  }
  disconnect() {
    this.xumm.logout();
  }
  onChange(cb: () => void) {
    this.xumm.on("success", cb);
  }
}

const provider = new XamanAdapter(
  // Rujira public API key
  "9ce0c336-4724-47e6-8f35-21ce088226bf"
);
export default provider;
